import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchUnits = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/units', { pagination: false }).then(units => {
    dispatch({
      type: types.FETCH_UNITS,
      payload: {
        units: units['hydra:member'],
      },
    });
  });
